import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SpaceLogo from '../../../../images/features/local_delivery/space_logo.jpg';
import SevenOrderLogo from '../../../../images/features/local_delivery/7order_logo.png';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(8, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    margin: theme.spacing(0, 2),
  },
  space: {
    width: '100%',
    maxWidth: 180,
    [theme.breakpoints.up('md')]: {
      maxWidth: 250,
    },
  },
  seven: {
    width: '100%',
    maxWidth: 100,
    [theme.breakpoints.up('md')]: {
      maxWidth: 140,
    },
  },
}));

const Partners = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <img
          src={SpaceLogo}
          alt="スペースシャワーTVプラス"
          className={clsx(classes.img, classes.space)}
        />
      </div>
      <div>
        <img
          src={SevenOrderLogo}
          alt="7ORDER"
          className={clsx(classes.img, classes.seven)}
        />
      </div>
    </div>
  );
};

export default Partners;
